import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import ThreadTypeForm from "./ThreadTypeForm";

function ThreadType() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "thread-types",
    id,
    { populate: ["imageLightMode", "imageDarkMode"] }
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/thread-types");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataThreadType: any) => {
      const threadType = { ...dataThreadType };

      try {
        if (threadType.id) {
          await updateItem(threadType.id, threadType);
        } else {
          await saveItem(threadType);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <ThreadTypeForm onSubmit={onSubmit} threadType={item} />
  );
}

export default ThreadType;
